$(window).resize(function () {
  massesSwipers();
  honorSwiper();
  honorhistory();
});

$(function () {
  //大事件
  $(".wd-readmore").click(function () {
    $(".dqwork-cont .wk-conts").css("height", "auto");
    $(this).hide();
  });
  //相关推荐
  $(".recommend-list ul li:even").css("margin-left", "0");

  $(".history-item .history-month:even")
    .find(".item-cont")
    .addClass("item-even");
  history();
  partySwipers();
  boutiqueSwipers();
  massesSwipers();
  //   honorSwiper();

  honorhistory();
  investorRelations();
});

//大事记
function history() {
  if ($(".box-history").length < 1) return false;
  var navli = $(".list-year");
  var posli = $(".history-items .history-item");
  var bar = $(".history-bar");
  var barH = bar.outerHeight(true);
  console.log(barH);
  var bartop = bar.offset().top;
  var yearArr = [];
  for (var i = 0; i < posli.length; i++) {
    yearArr[i] = posli.eq(i).offset().top;
  }
  navli.click(function () {
    var index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $("body,html")
      .stop()
      .animate({ scrollTop: yearArr[index] - barH + 1 }, 600);
    var textli = $(this).text();
    $(".current-year p").text(textli);
  });
  $(".history-list .btn-prev").click(function (e) {
    e.preventDefault();
    var _num = $(".list-year").filter(".active").index();
    if (--_num < 0) return;
    var i = _num;
    var _w = $(".list-year").eq(i).outerWidth(true);
    var _oleft;
    if (i <= 5) {
      _oleft = 0;
    } else if (i >= $(".list-year").length - 1) {
      _oleft = -_w * ($(".list-year").length - 7);
    } else {
      _oleft = -_w * (i - 6);
    }
    $(".list-year").parent().stop().animate({ left: _oleft }, 300);
    $(".list-year")
      .eq(i)
      .click()
      .addClass("active")
      .siblings()
      .removeClass("active");
  });
  $(".history-list .btn-next").click(function (e) {
    e.preventDefault();
    var _num = $(".list-year").filter(".active").index();
    if (++_num == $(".list-year").length) return; //_num=0;
    var i = _num;
    var _w = $(".list-year").eq(i).outerWidth(true);
    var _oleft;
    if (i <= 6) {
      _oleft = 0;
    } else if (i >= $(".list-year").length - 1) {
      _oleft = -_w * ($(".list-year").length - 7);
    } else {
      _oleft = -_w * (i - 6);
    }
    $(".list-year").parent().stop().animate({ left: _oleft }, 300);
    $(".list-year")
      .eq(i)
      .click()
      .addClass("active")
      .siblings()
      .removeClass("active");
  });
  var _top = $(document).scrollTop();
  var t;
  var prev = "";
  $(window).scroll(function () {
    var sctop = $(document).scrollTop();
    if (bartop <= sctop) {
      bar.addClass("fixed");
    } else {
      bar.removeClass("fixed");
    }
    for (var i = 0; i < yearArr.length; i++) {
      var j = i + 1;
      var res;
      if (i == yearArr.length - 1) {
        res = yearArr[i] <= sctop + barH + 20;
      } else {
        res = yearArr[i] <= sctop + barH + 20 && sctop + barH + 20 < yearArr[j];
      }
      if (res && prev != i) {
        var _w = $(".list-year").eq(i).outerWidth(true);
        var _oleft;
        if (i <= 6) {
          _oleft = 0;
        } else if (i >= $(".list-year").length - 1) {
          _oleft = -_w * ($(".list-year").length - 7);
        } else {
          _oleft = -_w * (i - 6);
        }
        $(".list-year").parent().stop().animate({ left: _oleft }, 300);
        $(".list-year")
          .eq(i)
          .addClass("active")
          .siblings()
          .removeClass("active");
        var textli = $(".list-year.active").text();
        $(".current-year p").text(textli);
        prev = i;
      }
    }
  });
}

//党群工作详情页轮播图
function partySwipers() {
  var partyslide = new Swiper(".party-swipers .swiper-container", {
    calculateHeight: true,
    loop: true,
    autoplay: 5000,
    watchActiveIndex: true,
    roundLengths: true,
    pagination: ".party-swipers .pagination",
    paginationClickable: true,
  });
}

//新闻加载更多
$(window).load(function () {
  if ($(".axnew-list").length) {
    var url = $(".axmore-btn").attr("url");

    new LoadMoreInfo($(".axnew-list"), url);
  }
});
function LoadMoreInfo(obj, url) {
  var _lobj = obj;
  var _lbtn = _lobj.find(".axmore-btn");
  var _len = _lobj.find("li").length;
  // var count = 1;
  var page = _lbtn.attr("pagenum") - 0;
  var curpage = 2;
  var loadFlag = true;
  _lbtn.click(function () {
    $.ajax({
      type: "post",
      url: url + curpage,
      datatype: "html",
      success: function (data) {
        curpage++;
        _lobj.find("ul").append(data);
        // if(count>0){
        //     loadFlag=true;
        // }
        if (page < curpage) {
          _lbtn.hide();
        }
      },
      error: function () {
        var _htmlbak = _lobj.find("li:lt(6)").clone();
        _lobj.find("ul").append(_htmlbak);
        if (count > 0) {
          loadFlag = true;
        }
        console.log("系统阵亡，正在开启复活程式......");
      },
    });
  });
}

//推荐新闻轮播图
function boutiqueSwipers() {
  var boutiqueslide = new Swiper(".choice-swiper .swiper-container", {
    calculateHeight: true,
    loop: true,
    autoplay: 5000,
    autoplayDisableOnInteraction: false,
    roundLengths: true,
    onInit: function (swiper) {
      swiper.swipeNext();
    },
  });

  $(".tjlf").click(function () {
    boutiqueslide.swipePrev();
  });
  $(".tjrt").click(function () {
    boutiqueslide.swipeNext();
  });
}

//党群工作列表切换展开收起
$(".screen-box .sn-text").click(function () {
  if ($(this).hasClass("on")) {
    $(this).removeClass("on");
    $(this).next().hide();
  } else {
    $(this).addClass("on");
    $(this).next().show();
  }
});
//党群工作轮播数据切换
$(".screen-box .sn-list ul li").click(function () {
  var sxli = $(this).attr("id");
  var sxname = $(this).text();
  $(this).closest(".sn-list").hide();
  $(this).closest(".screen-box").find(".sn-text").removeClass("on");
  $(this).closest(".screen-box").find(".sn-text p").text(sxname);
  var url = tabYearAjaxUrl;
  $.ajax({
    type: "post",
    url: url,
    data: { id: sxli },
    datatype: "html",
    success: function (data) {
      $(".screen-swipers .swiper-container").html("");
      $(".screen-swipers .swiper-container").html(
        '<div class="swiper-wrapper"></div>'
      );
      $(".screen-swipers .swiper-wrapper").html(data);
      massesSwipers();
    },
    error: function () {
      return;
    },
  });
});
//党群工作列表页轮播图
function massesSwipers() {
  var num;
  if ($(window).width() > 768) {
    num = 3;
  } else if ($(window).width() < 769) {
    num = 1;
  }
  var massesslide = new Swiper(".screen-swipers .swiper-container", {
    slidesPerView: num,
    slidesPerGroup: 1,
    calculateHeight: true,
    loop: true,
    autoplay: 5000,
    autoplayDisableOnInteraction: false,
    roundLengths: true,
    pagination: ".screen-swipers .pagination",
    paginationClickable: true,
    watchActiveIndex: true,
    centeredSlides: true,
  });
  setInterval(function check() {
    var total = $("#massess-swiper-wrapper-new").children().length - 2;
    $("#showhtml").html(massesslide.activeIndex + 1 + "/" + total);
  }, 100);
  $(".dqlf").click(function () {
    massesslide.swipePrev();
  });
  $(".dqrt").click(function () {
    massesslide.swipeNext();
  });
}

//集团荣誉和公益报告轮播模块
function honorhistory() {
  // debugger
  if ($(".years-swipers").length < 1) return false;
  var honorli = $(".honor-list .hr-year");
  var bar = $(".honor-years");
  var yearArr = [];
  $(".honor-list .hr-year").click(function () {
    var index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    var textli = $(this).text();
    $(".current-year p").text(textli);
    var type = $($(".years-swipers")[0]).attr("data-type");
    if (type && type === "honor") {
      tabhonor(index);
    }
  });
  $(".current-year .btn-prev").click(function (e) {
    e.preventDefault();
    var _num = $(".hr-year").filter(".active").index();

    if (--_num < 0) return;
    var i = _num;
    var _w = $(".hr-year").eq(i).outerWidth(true);
    var _oleft;
    if (i <= 5) {
      _oleft = 0;
    } else if (i >= $(".hr-year").length - 1) {
      _oleft = -_w * ($(".hr-year").length - 7);
    } else {
      _oleft = -_w * (i - 6);
    }
    $(".hr-year").parent().stop().animate({ left: _oleft }, 300);
    $(".hr-year").eq(i).addClass("active").siblings().removeClass("active");
    var sxli = $(".honor-list ul li.active a strong").text();
    $(".current-year p").text(sxli);

    var type = $($(".current-year")[0]).attr("data-type");
    if (type && type === "honor") {
      tabhonor(_num);
    }
  });
  $(".current-year .btn-next").click(function (e) {
    e.preventDefault();
    var _num = $(".hr-year").filter(".active").index();
    if (++_num == $(".hr-year").length) return; //_num=0;
    var i = _num;
    var _w = $(".hr-year").eq(i).outerWidth(true);
    var _oleft;
    if (i <= 6) {
      _oleft = 0;
    } else if (i >= $(".hr-year").length - 1) {
      _oleft = -_w * ($(".hr-year").length - 7);
    } else {
      _oleft = -_w * (i - 6);
    }
    $(".hr-year").parent().stop().animate({ left: _oleft }, 300);
    $(".hr-year").eq(i).addClass("active").siblings().removeClass("active");
    var sxli = $(".honor-list ul li.active a strong").text();
    $(".current-year p").text(sxli);

    var type = $($(".current-year")[0]).attr("data-type");
    if (type && type === "honor") {
      tabhonor(_num);
    }
  });
  tabhonor(0); // 初始化swiper
  function tabhonor(idx) {
    $(".group-honor-swiper .swiper-container").html("");
    $(".group-honor-swiper .swiper-container").html(
      '<div class="swiper-wrapper"></div>'
    );
    var htmlText = "";
    for (var i = 0; i < honorArr[idx].length; i++) {
      htmlText +=
        '<div class="swiper-slide">' +
        '<a href="javascript:;">' +
        '<div class="hr-pic">' +
        '<img src="' +
        honorArr[idx][i].img +
        '" alt="" />' +
        "</div>" +
        '<div class="hr-info">' +
        '<div class="date">' +
        honorArr[idx][i].date +
        "</div>" +
        '<div class="cont">' +
        "<p>" +
        honorArr[idx][i].text +
        "</p>" +
        "</div>" +
        "</div>" +
        '<div class="hr-month">' +
        honorArr[idx][i].month +
        "</div>" +
        "</a>" +
        "</div>";
    }
    $(".group-honor-swiper .swiper-wrapper").html(htmlText);
    if (honorArr[idx].length == 2) {
      honorSwiper(2);
      return;
    }
    honorSwiper();
  }
}
function honorSwiper(fnum) {
  var num;
  if ($(window).width() > 1024) {
    num = 4;
  } else if ($(window).width() > 768 && $(window).width() < 1025) {
    num = 2;
  } else if ($(window).width() < 769) {
    num = 1;
  }
  honorslide = new Swiper(".group-honor-swiper .swiper-container", {
    slidesPerView: fnum ? fnum : num,
    slidesPerGroup: 1,
    calculateHeight: true,
    loop: true,
    autoplay: 5000,
    autoplayDisableOnInteraction: false,
    roundLengths: true,
  });
  $(".gh-lf")
    .off("click")
    .click(function () {
      honorslide.swipePrev();
    });
  $(".gh-rt")
    .off("click")
    .click(function () {
      honorslide.swipeNext();
    });
}

//投资者关系
function investorRelations() {
  if ($(".investor-relations").length < 1) return false;
  var investorli = $(".ir-year");
  var bar = $(".investor-years");
  //年份切换
  investorli.click(function () {
    $(this).addClass("active").siblings().removeClass("active");
    var textli = $(this).text();
    $(".current-investor p").text(textli);
    var sxli = $(this).find("a").attr("id");
    $(".investor-quarter ul li ")
      .eq(0)
      .addClass("active")
      .siblings()
      .removeClass("active");
    pdyear = sxli;
    pdjd = 1;
    tabinvestor(pdyear, pdjd);
  });
  //左右按钮
  $(".current-investor .btn-prev").click(function (e) {
    e.preventDefault();
    var _num = $(".ir-year").filter(".active").index();
    if (--_num < 0) return;
    var i = _num;
    var _w = $(".ir-year").eq(i).outerWidth(true);
    var _oleft;
    if (i <= 5) {
      _oleft = 0;
    } else if (i >= $(".ir-year").length - 1) {
      _oleft = -_w * ($(".ir-year").length - 7);
    } else {
      _oleft = -_w * (i - 6);
    }
    $(".ir-year").parent().stop().animate({ left: _oleft }, 300);
    $(".ir-year").eq(i).addClass("active").siblings().removeClass("active");
    var sxli = $(".investor-list ul li.active a").attr("id");
    var sxli2 = $(".investor-list ul li.active a").text();
    $(".current-investor p").text(sxli2);
    $(".investor-quarter ul li ")
      .eq(0)
      .addClass("active")
      .siblings()
      .removeClass("active");
    pdyear = sxli;
    pdjd = 1;
    tabinvestor(pdyear, pdjd);
  });
  $(".current-investor .btn-next").click(function (e) {
    e.preventDefault();
    var _num = $(".ir-year").filter(".active").index();
    if (++_num == $(".ir-year").length) return; //_num=0;
    var i = _num;
    var _w = $(".ir-year").eq(i).outerWidth(true);
    var _oleft;
    if (i <= 6) {
      _oleft = 0;
    } else if (i >= $(".ir-year").length - 1) {
      _oleft = -_w * ($(".ir-year").length - 7);
    } else {
      _oleft = -_w * (i - 6);
    }
    $(".ir-year").parent().stop().animate({ left: _oleft }, 300);
    $(".ir-year").eq(i).addClass("active").siblings().removeClass("active");
    var sxli = $(".investor-list ul li.active a").attr("id");
    $(".current-investor p").text(sxli);
    var sxli2 = $(".investor-list ul li.active a").text();
    $(".current-investor p").text(sxli2);
    $(".investor-quarter ul li ")
      .eq(0)
      .addClass("active")
      .siblings()
      .removeClass("active");
    pdyear = sxli;
    pdjd = 1;
    tabinvestor(pdyear, pdjd);
  });
  //季度切换
  $(".investor-quarter ul li").click(function (e) {
    $(this).addClass("active").siblings().removeClass("active");
    var qrli = $(".investor-quarter ul li.active ").index();
    pdjd = qrli + 1;
    tabinvestor(pdyear, pdjd);
  });

  function tabinvestor(year, quarter) {
    var url = tabYearAjaxUrl + "&year=" + year + "&quarter=" + quarter;
    $.ajax({
      type: "get",
      url: url,
      year: year,
      quarter: quarter,
      datatype: "html",
      success: function (data) {
        $(".investor-relations-lists .ls-container").html(data);
        pageLoadmore();
      },
      error: function () {
        return;
      },
    });
  }

  function pageLoadmore() {
    //页码切换
    $(".ls-container .page-list a").click(function () {
      var pgUrl = $(this).attr("href");
      $.ajax({
        type: "post",
        url: pgUrl,
        datatype: "html",
        success: function (data) {
          $(".investor-relations-lists .ls-container").html(data);
          pageLoadmore();
        },
        error: function () {
          return;
        },
      });
    });
  }
}

// $(function(){
//     $(window).scroll(function(event) {
//         var zsbox = $(".animateNum").offset().top;
//         var zsscr = $(document).scrollTop();
//         var winheight = $(window).height();
//         var vue = zsbox-zsscr;
//         if(vue<winheight){
//             numAni($(".animateNum-1"),3.2,0.3);
//             numAni($(".animateNum-2"),15,1);
//             numAni($(".animateNum-3"),10000,100);
//         }

//     });

//     function numAni(el,endVal,addVal){
//         add();
//         function add(){
//             var value01 = $(el).text();
//             if(value01>=endVal){
//                 $(el).text(endVal);
//                 return null;
//             }
//             value01 = parseFloat(value01) + addVal;
//             value01 = Math.round(value01*100)/100;
//             $(el).text(value01);
//             setTimeout(add,100);
//         }
//     }
// })
